

























































































































import { setCookie, getCookie, inGame, addGA } from '../utils'
import { Vue, Component, Watch } from 'vue-property-decorator'
import ffButton from '@/components/public/Button.vue'
import { namespace } from 'vuex-class'
import { Toast } from 'vant'

const appStore = namespace('app')

@Component({
  components: {
    ffButton
  }
})
export default class Home extends Vue {
  @appStore.State(state => state.transify) private transify: any
  @appStore.State(state => state.isLogin) private isLogin: boolean
  @appStore.State(state => state.downloadOpen) private downloadOpen: boolean
  @appStore.State(state => state.registerOpen) private registerOpen: boolean
  @appStore.State(state => state.isRegister) private isRegister: boolean
  @appStore.State(state => state.loginFrom) private loginFrom: string
  @appStore.State(state => state.indexInit) private indexInit: boolean
  @appStore.State(state => state.has_activation_code) private has_activation_code: number
  @appStore.Action('login') private login!: Function
  @appStore.Action('setUserInfo') private setUserInfo!: Function
  @appStore.Action('setLoginFrom') private setLoginFrom!: Function

  private timer: any = null
  private activiteIndex: number = -1
  get benefit(): Array<object> {
    return [
      {
        title: this.transify['ADV_BENEFIT_SUBTITLE_1'] || '',
        context: this.transify['ADV_BENEFIT_SUBTITLE_1_CONTEXT'] || ''
      },
      {
        title: this.transify['ADV_BENEFIT_SUBTITLE_2'] || '',
        context: this.transify['ADV_BENEFIT_SUBTITLE_2_CONTEXT'] || ''
      },
      {
        title: this.transify['ADV_BENEFIT_SUBTITLE_3'] || '',
        context: this.transify['ADV_BENEFIT_SUBTITLE_3_CONTEXT'] || ''
      }
    ]
  }

  get isInGame(): boolean {
    return inGame()
  }

  setBenefitIdx(idx: number): string {
    return idx < 10 ? `0${idx + 1}.` : `${idx + 1}.`
  }

  eventLogin(type: string): void {
    if (this.has_activation_code === 1) {
      Toast(this.transify['ADV_TOAST01'])
      addGA('eventLogin', 'false')
    } else {
      addGA('eventLogin', type)
      this.login(type)
    }
  }

  userInfo(accessToken: string): void {
    this['$http'].get(`/info?live_access_token=${accessToken}&login_from=${this.loginFrom}`).then((res: any) => {
      this.setUserInfo(res.data)
    })
  }
  @Watch('indexInit', { immediate: false, deep: true })
  watchIndexInit(val: any, old: any) {
    if (val) {
      this.init()
    }
  }

  @Watch('isLogin', { immediate: false, deep: true })
  watchIsLogin(val: any, old: any) {
    if (val) {
      if (this.registerOpen) {
        if (!this.isRegister) {
          this['$router'].push({ path: 'register' }).catch(() => {
            return
          })
        } else {
          this['$router'].push({ path: 'download' }).catch(() => {
            return
          })
        }
      }
    }
  }

  init(): void {
    clearTimeout(this.timer)
    if (this.indexInit) {
      const accessToken = this['$route'].query['access_token'] || getCookie('liveAccessToken')
      if (this['$route'].query['access_token']) {
        setCookie('liveAccessToken', accessToken)
        inGame() && this.setLoginFrom('game')
      }
      if (getCookie('liveAccessToken')) {
        this.userInfo(accessToken)
      }
    } else {
      this.timer = setTimeout(() => {
        this.init()
      }, 1000)
    }
  }

  showContent(index: number): void {
    if (this.activiteIndex === index) {
      this.activiteIndex = -1
    } else {
      this.activiteIndex = index
    }
  }

  mounted(): void {
    this.init()
  }
}
